/** Badging API есть не во всех браузерах, поэтому типы DOM его не гарантируют. */
type BadgeNavigator = Navigator & {
  setAppBadge?: (count?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

/**
 * Ставит число непрочитанных на иконку установленного приложения.
 *
 * Push с сервера выставляет число, пока приложение закрыто, а здесь оно
 * выравнивается, когда приложение открыто: прочитали уведомления — число ушло,
 * прочитали на другом устройстве — при следующем запросе счётчика тоже. Без
 * этого число, выставленное push-ом, висело бы на иконке вечно.
 *
 * Там, где Badging API нет, и при отказе ничего не происходит: бейдж —
 * украшение, а не часть работы. На iPhone он работает только в приложении,
 * установленном на экран «Домой», и только при выданном разрешении на
 * уведомления.
 */
export async function syncAppBadge(
  count: number,
  target: BadgeNavigator = navigator,
): Promise<void> {
  try {
    if (count > 0) await target.setAppBadge?.(count);
    else await target.clearAppBadge?.();
  } catch {
    // Разрешения нет или API отказал — число на иконке не обязательно.
  }
}
